<template>
  <svg width="22" height="24" viewBox="0 0 22 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_560_4200)">
<path d="M8.24992 22C8.75618 22 9.16659 21.5523 9.16659 21C9.16659 20.4477 8.75618 20 8.24992 20C7.74366 20 7.33325 20.4477 7.33325 21C7.33325 21.5523 7.74366 22 8.24992 22Z" stroke="#464646" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M18.3334 22C18.8397 22 19.2501 21.5523 19.2501 21C19.2501 20.4477 18.8397 20 18.3334 20C17.8272 20 17.4167 20.4477 17.4167 21C17.4167 21.5523 17.8272 22 18.3334 22Z" stroke="#464646" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M0.916748 1H4.58342L7.04008 14.39C7.12391 14.8504 7.3535 15.264 7.68867 15.5583C8.02383 15.8526 8.44322 16.009 8.87342 16H17.7834C18.2136 16.009 18.633 15.8526 18.9682 15.5583C19.3033 15.264 19.5329 14.8504 19.6167 14.39L21.0834 6H5.50008" stroke="#464646" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_560_4200">
<rect width="22" height="24" fill="white"/>
</clipPath>
</defs>
</svg>

</template>